'use client';

import { createContext, useState, useEffect } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';

export enum ThemeMode {
    Light = 'light',
    Dark = 'dark',
}

export interface AppContextProps {
    //lang: Lang;
    //langs: Lang[];
    userCookiesPreferences: null | CookieConsent.UserPreferences;
    setAppState: (state: Partial<AppContextProps>) => void;
}

const initialAppState = {
    //lang: i18n.defaultLang,
    // langs: i18n.langs,
    navigation: { drawer: { open: false } },
    userCookiesPreferences: null,
    setAppState: (state: Partial<AppContextProps>) => {},
};

export const AppContext = createContext<AppContextProps>(initialAppState);

interface Props {
    children: React.ReactNode;
}

export function AppContextProvider(props: Props) {
    const [appState, setAppState] = useState<AppContextProps>(initialAppState);

    useEffect(() => {
        setAppState((state: AppContextProps) => {
            return {
                ...state,
                userCookiesPreferences: CookieConsent.getUserPreferences(),
            };
        });
    }, []);

    return (
        <AppContext.Provider
            value={{
                ...appState,
                setAppState: (state: Partial<AppContextProps>) => {
                    setAppState((s: AppContextProps) => {
                        return { ...s, ...state };
                    });
                },
            }}
        >
            {props.children}
        </AppContext.Provider>
    );
}
